import React, { useEffect } from 'react';
import MobileProductForm from './MobileProductMISCForm'
import { Paper, withStyles } from "@material-ui/core";
import { hasPermission, parseURL } from '../../../sc-utilities';
import { connect } from "react-redux";
import * as actions from "../store/mobileProductActions";
import {getProductType} from "../../../sc-admin/SystemCertificate/utils";

const styles = theme => ({
    root: {
        width: `100%`,
        height: 'auto',
        marginTop: '-43px',
        [theme.breakpoints.down('md')]: {
            marginTop: '-21px',
            width: '100%'
        },
        [theme.breakpoints.down('sm')]: {
            marginTop: '-21px',
            width: '100%'
        }
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    cancel: {
        width: "250px",
        margin: "10px"
    }
});

const MobileProductEditMisc = props => {
    const { product, loading, editable, classes, activeCustomer, translations, permissions, onFetchMobileProduct } = props;
    let searchParams = parseURL(window.location.search);

    const handleSubmit = async data => {
        data['ActiveCustomerID'] = activeCustomer;
        data['updateMISCOnly'] = true;
        data['ProductID'] = searchParams?.productID;
        await props.onEditMobileProduct({ ...data });
    }

    const getSecurazeVersion = (processingSession) => {
        if (processingSession?.ClientType) {
            return `${getProductType(processingSession?.ClientType ?? "", translations)}: ${processingSession?.ClientVersion ?? ""}`;
        }
        return processingSession?.ClientVersion ?? "";
    }

    let initialValues = {
        OperatingSystem: product && product.MobileProduct && product.MobileProduct.OperatingSystem ? product.MobileProduct.OperatingSystem : '',
        OperatingSystemVersionPreProcessing: product && product.MobileProduct && product.MobileProduct.OperatingSystemVersionPreProcessing ? product.MobileProduct.OperatingSystemVersionPreProcessing : '',
        OperatingSystemVersion: product && product.MobileProduct && product.MobileProduct.OperatingSystemVersion ? product.MobileProduct.OperatingSystemVersion : '',
        ScreenSize: product && product.MobileProduct && product.MobileProduct.ScreenSize ? product.MobileProduct.ScreenSize : '',
        CPUArchitecture: product && product.MobileProduct && product.MobileProduct.CPUArchitecture ? product.MobileProduct.CPUArchitecture : '',
        ApiLevel: product && product.MobileProduct && product.MobileProduct.ApiLevel ? product.MobileProduct.ApiLevel : '',
        Processor: product && product.MobileProduct && product.MobileProduct.Processor ? product.MobileProduct.Processor : '',
        BuiltDate: product && product.MobileProduct && product.MobileProduct.BuiltDate ? product.MobileProduct.BuiltDate : '',
        DeviceColor: product && product.MobileProduct && product.MobileProduct.DeviceColor ? product.MobileProduct.DeviceColor : '',
        NetworkStandard: product && product.MobileProduct && product.MobileProduct.NetworkStandard ? product.MobileProduct.NetworkStandard : '',
        ProductIdentifier: product && product.MobileProduct && product.MobileProduct.ProductIdentifier ? product.MobileProduct.ProductIdentifier : '',
        ProductVersion: product && product.MobileProduct && product.MobileProduct.ProductVersion ? product.MobileProduct.ProductVersion : '',
        AvailableSimCardSlots: product && product.MobileProduct && product.MobileProduct.AvailableSimCardSlots ? product.MobileProduct.AvailableSimCardSlots : '',
        InstalledSimCards: product && product.MobileProduct && (product.MobileProduct.InstalledSimCards || product.MobileProduct.InstalledSimCards===0)? Number(product.MobileProduct.InstalledSimCards) : '',
        SdCardAmount: product && product.MobileProduct && (product.MobileProduct.SdCardAmount || product.MobileProduct.SdCardAmount===0)? Number(product.MobileProduct.SdCardAmount): '',
        ANumber: product && product.MobileProduct && product.MobileProduct.ANumber? product.MobileProduct.ANumber : '',
        SecurazeVersion: getSecurazeVersion(product?.ProcessingSessions?.[0]),
        HardwareID: product && product.HardwareID ? product.HardwareID : '',
        IsRooted: product?.MobileProduct?.IsRooted,
        ManufactoryDate: product && product.MobileProduct && product.MobileProduct.ManufactoryDate? product.MobileProduct.ManufactoryDate : '',
        ECID: product && product.MobileProduct.ECID ? product.MobileProduct.ECID : '',
        MEID: product && product.MobileProduct.MEID ? product.MobileProduct.MEID : '',
    };

    let formSettings = {
        Validation: {
        },
        ButtonSubmit: hasPermission(permissions, "product_save")
            ? {
                Title: translations["save"] || "SAVE",
                Color: 'primary'
            }
            : null,
    };

    useEffect(() => {
        const getProduct = async () => {
            await onFetchMobileProduct({ActiveCustomerID: activeCustomer, ProductID: searchParams?.productID});
        }
        getProduct();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (<>< Paper className={classes.root} >
                <MobileProductForm
                    formSettings={formSettings}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    editable={editable}
                    loading={loading}
                    translations={translations}
                ></MobileProductForm>
            </Paper>
        </>)
}

const mapStateToProps = state => {
    return {
        product: state?.product?.mobileProducts?.loaded,
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onEditMobileProduct: product => dispatch(actions.editMobileProduct(product)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(MobileProductEditMisc));
